export default function JobsInfo(){
    return (
        <div>Jobs Info</div>
    )
}